import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Search, Close } from '@mui/icons-material';
import { IconButton, TextField } from '@totalsoft/rocket-ui';

const ReportsFilters = ({ t, filters, onFilterValueChanged, resetFilters }) => {
  const onTextFilterChanged = useCallback(
    name => value => {
      onFilterValueChanged(name, value, true);
    },
    [onFilterValueChanged]
  );

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6} lg={4}>
        <TextField
          fullWidth
          label={t('Reports.ReportName')}
          value={filters.reportName}
          onChange={onTextFilterChanged('reportName')}
          startAdornment={<Search />}
          endAdornment={
            <IconButton tooltip={t('Tooltips.ResetFilters')} color='primary' variant='text' size='tiny' onClick={resetFilters}>
              <Close />
            </IconButton>
          }
        />
      </Grid>
    </Grid>
  );
};

ReportsFilters.propTypes = {
  t: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    reportName: PropTypes.string
  }),
  onFilterValueChanged: PropTypes.func.isRequired,
  resetFilters: PropTypes.func.isRequired
};

export default compose(withTranslation())(ReportsFilters);
